import i18next, { i18n } from 'i18next';
import { RootUpdatable, RootProps } from '../types';
// @ts-ignore
import { createInstance, LocalizationModule } from '@unitedtraders/i18n';
import { getLocales } from './getLocales';

export class I18Service implements RootUpdatable {
  public i18next: i18n;

  constructor(locale: string) {
    this.i18next = i18next.createInstance();
    const locales = getLocales();

    this.i18next.init({
      interpolation: {
        escapeValue: false,
      },
      lng: locale,
      resources: locales,
      fallbackLng: 'en',
      supportedLngs: ['en', 'ru', 'es'],
    });
  }

  update(attrs: RootProps) {
    this.i18next.changeLanguage(attrs.locale);
  }
}
